<svg:g [style.opacity]="caliper.opacity">
    <g
        (positionChange)="onPositionChange($event)"
        (removeClicked)="onRemoveCaliper()"
        [measures]="measures"
        [window]="caliper.window"
        caliper-window
        id="window"
    ></g>

    <g (intersectionChange)="onPointer1IntersectionChange()" [pointer]="caliper.pointer1" trace-pointer></g>
    <g (intersectionChange)="onPointer2IntersectionChange()" [pointer]="caliper.pointer2" trace-pointer></g>

    <!--<g trace-measure [measure]="caliper.measure"></g>-->
</svg:g>
